const { VUE_APP_API_URL } = process.env;
export default {
  API_URL: VUE_APP_API_URL,
};
